export default function BandcampSection() {
  const albums = [
    {
      title: "Ice Drones",
      url: "https://tonygerber.bandcamp.com/album/ice-drones",
      description: "Atmospheric soundscapes and frozen textures that evoke the stark beauty of winter landscapes."
    },
    {
      title: "Snow Drone",
      url: "https://tonygerber.bandcamp.com/album/snow-drone",
      description: "Gentle drifting tones that capture the quiet solitude and crystalline patterns of falling snow."
    },
    {
      title: "Origami Drones",
      url: "https://tonygerber.bandcamp.com/album/origami-drones",
      description: "Intricate layered harmonics folding and unfolding like sonic paper sculptures in slow motion."
    }
  ];

  return (
    <section id="listen" className="bandcamp-section">
      <div className="section-content">
        <h2>listen</h2>
        <p className="section-intro">Tony Gerber's ambient drone explorations</p>

        <div className="albums-grid">
          {albums.map((album, index) => (
            <div key={index} className="album-card">
              <div className="album-artwork">
                <div className="artwork-placeholder">
                  <svg viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="0.5">
                    <circle cx="50" cy="50" r="45" />
                    <circle cx="50" cy="50" r="30" />
                    <circle cx="50" cy="50" r="15" />
                  </svg>
                </div>
              </div>

              <div className="album-details">
                <h3>{album.title}</h3>
                <p className="album-artist">by Tony Gerber</p>
                <p className="album-description">{album.description}</p>

                <a
                  href={album.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bandcamp-link"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/>
                  </svg>
                  Listen on Bandcamp
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="bandcamp-note">
          <p>Explore the full discography and support the artist directly on Bandcamp</p>
        </div>
      </div>
    </section>
  );
}
